import { Link } from 'core/i18n/navigation';
import { appRoutes } from 'config';
import { reportUserClickedOnEvent } from 'utils/analytics/segment';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useLoginModalTrigger } from 'hooks/useLoginModalTrigger';

interface Props {
  className?: string;
}

export const StartNowButton = ({ className }: Props) => {
  const t = useTranslations();
  const openLoginModal = useLoginModalTrigger(appRoutes.LOGIN);
  return (
    <Link
      href={appRoutes.LOGIN}
      className={classNames(styles.base, className)}
      onClick={(event) => {
        reportUserClickedOnEvent('Get Started', 'Homepage Hero');
        openLoginModal(event);
      }}
    >
      {t('auth.startNow')}
    </Link>
  );
};

const styles = {
  base: classNames(
    'block text-center px-7 py-3 text-xl font-medium leading-8',
    'bg-mf-blue text-white rounded-full',
    'shadow-md hover:shadow-lg hover:opacity-95',
    'transition duration-150 ease-in-out',
  ),
};
